import { Typography, Button, TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AddIcon from "@mui/icons-material/Add";
import LockIcon from "@mui/icons-material/Lock";
import ReplyCard from "./ReplyCard";
import api from "../../api/api";
import { useApp } from "../../context/AppContext";

import "../../assets/style/SupportTickets.css";
import "../../assets/style/Styles.css";
import { useEffect, useState } from "react";

export default function TicketView({ ticket, onBack }) {
	const { user, fetchUser, fetchTickets } = useApp();
	const [allMessages, setAllMessages] = useState(ticket.messages || []);
	const [textAreaMsg, setTextAreaMsg] = useState("");
	const [currentTicket, setCurrentTicket] = useState(ticket);
	const [isSending, setIsSending] = useState(false);

	// Функция для определения класса статуса
	const getStatusClass = (status) => {
		console.log('=== TICKET VIEW DEBUG STATUS ===');
		console.log('Original status:', status);
		console.log('Type of status:', typeof status);
		
		if (!status) {
			console.log('Status is empty, returning open');
			return 'ticket-status status-open';
		}
		
		const statusLower = status.toLowerCase().trim();
		console.log('Status lower:', statusLower);
		
		if (statusLower === 'closed' || statusLower === 'close') {
			console.log('Status is closed, returning closed class');
			return 'ticket-status status-closed';
		}
		
		console.log('Status is not closed, returning open class');
		return 'ticket-status status-open';
	};

	// Загружаем актуальные данные тикета и пользователя при монтировании
	useEffect(() => {
		const loadData = async () => {
			// Если данные пользователя не загружены, загружаем их
			if (!user) {
				try {
					await fetchUser();
				} catch (err) {
					console.log('Error loading user data:', err);
				}
			}
			// Загружаем данные тикета
			await refreshTicketData();
		};

		loadData();
	}, []);

	// Функция для обновления данных тикета
	const refreshTicketData = async () => {
		try {
			const response = await api.get(`/tickets/${ticket.id}`, {
				headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` }
			});
			const updatedTicket = response.data;
			setCurrentTicket(updatedTicket);
			setAllMessages(updatedTicket.messages || []);
		} catch (err) {
			console.log('Error refreshing ticket data:', err);
		}
	};

	const sendReply = async (event) => {
		event.preventDefault();
		if (!textAreaMsg.trim() || isSending) return;

		setIsSending(true);
		const ticketReqBody = {
			"ticket_id": ticket.id,
			"from": "client",
			"content": textAreaMsg,
			"attachments": null,
			"author_name": user?.email || "client" // Добавляем email пользователя
		}
		try{
			const sendMesgRes = await api.post("/messages", ticketReqBody, {headers:{Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`}});
			console.log('New message response:', sendMesgRes.data);
			
			// Очищаем поле ввода
			setTextAreaMsg("");
			
			// Обновляем данные тикета с сервера
			await refreshTicketData();
			
			// Обновляем список тикетов
			try {
				await fetchTickets();
			} catch (refreshError) {
				console.log('Error refreshing tickets list:', refreshError);
			}
		}catch(err){
			console.log('Error sending message:', err);
		} finally {
			setIsSending(false);
		}
	}

	const closeTicket = async () => {
		console.log('=== CLOSE TICKET FUNCTION STARTED ===');
		console.log('textAreaMsg:', textAreaMsg);
		console.log('isSending:', isSending);
		console.log('ticket.id:', ticket.id);
		
		if (!textAreaMsg.trim() || isSending) {
			console.log('=== VALIDATION FAILED - EXITING ===');
			return;
		}
		
		console.log('=== SETTING IS_SENDING TO TRUE ===');
		setIsSending(true);
		
		try {
			console.log('=== STEP 1: SENDING MESSAGE ===');
			// Сначала отправляем сообщение
			const ticketReqBody = {
				"ticket_id": ticket.id,
				"from": "client",
				"content": textAreaMsg,
				"attachments": null,
				"author_name": user?.email || "client"
			};
			
			console.log('Message request body:', ticketReqBody);
			const messageResponse = await api.post("/messages", ticketReqBody, {
				headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` }
			});
			console.log('=== MESSAGE SENT SUCCESSFULLY ===');
			console.log('Message response:', messageResponse.data);
			
			// Очищаем поле ввода
			setTextAreaMsg("");
			console.log('=== TEXT AREA CLEARED ===');
			
			console.log('=== STEP 2: SENDING PUT REQUEST ===');
			// Затем закрываем тикет - используем PUT запрос
			const closeTicketData = {
				status: "closed"
			};
			
			console.log('PUT request data:', closeTicketData);
			console.log('PUT request URL:', `/tickets/${ticket.id}`);
			console.log('About to make PUT request...');
			
			// Явно создаем PUT запрос
			const putUrl = `/tickets/${ticket.id}`;
			const putData = { status: "closed" };
			const putHeaders = { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` };
			
			console.log('PUT URL:', putUrl);
			console.log('PUT Data:', putData);
			console.log('PUT Headers:', putHeaders);
			
			const closeResponse = await api.put(putUrl, putData, { headers: putHeaders });
			console.log('=== PUT REQUEST SUCCESSFUL ===');
			console.log('PUT response:', closeResponse.data);
			
			// Обновляем локальное состояние тикета
			setCurrentTicket(prev => ({
				...prev,
				status: "closed"
			}));
			console.log('=== LOCAL STATE UPDATED ===');
			
			console.log('=== STEP 3: REFRESHING TICKET DATA ===');
			// Обновляем данные тикета с сервера для подтверждения
			try {
				await refreshTicketData();
				console.log('=== TICKET DATA REFRESHED ===');
			} catch (refreshError) {
				console.log('Error refreshing ticket data:', refreshError);
			}
			
			console.log('=== STEP 4: GOING BACK TO LIST ===');
			// Обновляем список тикетов перед возвратом
			try {
				await fetchTickets();
				console.log('=== TICKETS LIST REFRESHED ===');
			} catch (refreshError) {
				console.log('Error refreshing tickets list:', refreshError);
			}
			
			// Возвращаемся к списку тикетов
			onBack();
			
			// Принудительно обновляем страницу для тестирования
			setTimeout(() => {
				window.location.reload();
			}, 1000);
			
		} catch (err) {
			console.log('=== ERROR IN CLOSE TICKET FUNCTION ===');
			console.log('Error object:', err);
			console.log('Error message:', err.message);
			console.log('Error response:', err.response?.data);
			console.log('Error status:', err.response?.status);
			console.log('Error config:', err.config);
		} finally {
			console.log('=== SETTING IS_SENDING TO FALSE ===');
			setIsSending(false);
		}
	}
	const openTicket = async () => {
		if (!textAreaMsg.trim() || isSending) return;

		setIsSending(true);
		try {
			// 1. сообщение
			await api.post(
				"/messages",
				{
					ticket_id: ticket.id,
					from: "client",
					content: textAreaMsg,
					attachments: null,
					author_name: user?.email || "client",
				},
				{ headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` } }
			);

			setTextAreaMsg("");

			// 2. открыть тикет
			await api.put(
				`/tickets/${ticket.id}`,
				{ status: "open" },
				{ headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` } }
			);

			await refreshTicketData();
			await fetchTickets();
		} catch (err) {
			console.log("Error opening ticket:", err);
		} finally {
			setIsSending(false);
		}
	};


	const isClosed = (status) => {
		const s = (status || "").toString().toLowerCase().trim();
		return s === "closed" || s === "close";
	};

	const isOpen = (status) => !isClosed(status);

  if (!ticket) return null;

  return (
    <div className="ticket-view-container">
      <div className="page-header">
        <div>
          {currentTicket.subject && (
            <Typography variant="h5" className="ticket-subject-title">
              {currentTicket.subject}
            </Typography>
          )}
          <Typography variant="h4" className="page-title">
            {currentTicket.ticket_id || currentTicket.id}
          </Typography>
          {currentTicket.uuid && 
           currentTicket.uuid !== currentTicket.ticket_id && 
           currentTicket.uuid !== currentTicket.id && 
           currentTicket.uuid !== currentTicket.ticket_id?.toString() && 
           currentTicket.uuid !== currentTicket.id?.toString() && (
            <Typography className="ticket-view-id">{currentTicket.uuid}</Typography>
          )}
        </div>
        <div className="header-actions">
          <span
            className={getStatusClass(currentTicket.status)}
          >
            {currentTicket.status?.toUpperCase() || 'OPEN'}
          </span>
          <Button
            variant="outlined"
            className="go-back-button"
            startIcon={<ArrowBackIcon />}
            onClick={onBack}
          >
            Go Back
          </Button>
        </div>
      </div>

      <div className="reply-form-section">
		<form onSubmit={sendReply} style={{width:"100%"}}>
			<TextField
				label="Message"
				multiline
				rows={4}
				fullWidth
				className="custom-textfield"
				onChange={(e)=> setTextAreaMsg(e.target.value)}
				value={textAreaMsg}
				placeholder="Please write descriptively what your query is about."
			/>

			<div className="reply-form-actions">

				{/* OPEN ticket */}
				{isOpen(currentTicket.status) && (
					<>
						<Button
							variant="contained"
							type="button"
							onClick={(e) => {
								e.preventDefault();
								closeTicket(); // закрываем тикет + отправляем сообщение
							}}
							className="action-button-secondary"
							startIcon={<LockIcon />}
							disabled={isSending}
						>
							{isSending ? "Sending..." : "Add Reply & Close Ticket"}
						</Button>

						<Button
							variant="contained"
							type="submit"
							className="create-ticket-button"
							startIcon={<AddIcon />}
							disabled={isSending}
						>
							{isSending ? "Sending..." : "+ Add Reply"}
						</Button>
					</>
				)}

				{/* CLOSED ticket */}
				{isClosed(currentTicket.status) && (
					<Button
						variant="contained"
						type="button"
						onClick={(e) => {
							e.preventDefault();
							openTicket(); // откроем тикет + отправим сообщение
						}}
						className="action-button-secondary"
						startIcon={<LockIcon />}
						disabled={isSending}
					>
						{isSending ? "Sending..." : "Add Reply & Open Ticket"}
					</Button>
				)}

			</div>
		</form>
      </div>

      <div className="replies-section">
        <div className="replies-header">
          <Typography variant="h6" className="replies-title">
            Replies
          </Typography>
        </div>
        <div className="replies-list">
          {allMessages.length > 0 ? (
            allMessages.map(reply => (
              <ReplyCard key={reply.id} reply={reply} />
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No replies yet
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
